import React, { useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import "../ReportTabs/ReportCss/PersonalArea.css"
import {
  MenuItem, Button, FormControl, Select, TextareaAutosize
} from '@mui/material' //TextField, 

import TextField from "@material-ui/core/TextField"; 
import { ArrowLeftRounded } from "@mui/icons-material";


const PersonalArea = (props) => {

  const { cntrct, cntComp, currentKey } = props
  const [value, setValue] = useState()
  const [contactObj, setContactObj] = useState({
    nameFirst: "", emailFirst: "", PhoneFirst: "",
    nameSecond: "", emailSecond: "", PhoneSecond: "",
    message: "", contactType: ""
  })
  const handleChange = (event, id) => {
    let CopyContactObj = { ...contactObj }
    CopyContactObj[id] = event.target.value
    setContactObj(CopyContactObj);
  };

  function CreateActivity()
  {
    debugger;
    var res;
    var errorMsg = '';

    if (contactObj.emailFirst.length > 0 && !contactObj.emailFirst.includes("@"))
    {
      alert("יש להכניס מייל תקין");
      return;
    }

    if(contactObj.PhoneFirst.length < 9)
    {
      alert("יש להכניס טלפון תקין");
      return;
    }

  
    const requestOptions = { 
         method: 'POST',
         headers: { 'Content-Type': 'application/json'},
         body: JSON.stringify({ cntrctNum : cntrct,  comp: cntComp,  name1 : contactObj.nameFirst,  mail1: contactObj.emailFirst,  phone1: contactObj.PhoneFirst
                                         ,  name2: contactObj.nameSecond,  mail2: contactObj.emailSecond,  phone2: contactObj.PhoneSecond
                                         ,  type: contactObj.contactType,  innerMsg: contactObj.message })
  };
  fetch('https://webservice.tuboul.co.il:5678/ContractData/CreateActivity', requestOptions)
        .then(response => response.json())
        .then(response => {res =response})
        .catch((error) => { console.log('error-- ' + error); errorMsg = error;})
      // .then(response => response.json())
      // .then(data => this.setState({ postId: data.id }));
      console.log(res);
      // alert(errorMsg != "OK"  ? 'תקלה בשליחת הנתונים ' +errorMsg : 'תודה על פניתך, אנו ניצור איתך קשר תוך 3 ימי עסקים');
      
      alert('תודה על פניתך, אנו ניצור איתך קשר תוך 3 ימי עסקים');
      

  //       try{
     
  //   const response = await fetch('http://82.80.69.108:5678/ContractData/CreateActivity', requestOptions);
  //   const data = await response.json();
     
  // }
  // catch(error){
  //    errorMsg = error;
  // }

      // if(errorMsg == "OK")
      // {
        setContactObj ({
          nameFirst: "", emailFirst: "", PhoneFirst: "",
          nameSecond: "", emailSecond: "", PhoneSecond: "",
          message: "", contactType: ""
        });
      // }
  }

  return (
    <div className="personal-area">
      <div className="personal-area-div">

        <div class="main-text">
          <p >  נשמח לשמוע מכם. ניתן להשאיר לנו הודעה ואנו נחזור בהקדם</p>
          <h1> אנחנו כאן לשירותכם</h1>
          <div className="imgCU"><img className="imgCU" style={{margin:55, height:window.innerHeight/2, width:window.innerWidth/2.6}}
             src={"/images/Pictures/247585.jpg"}></img></div>
        </div>
      </div>
      < div className="personal-area-div2">
        <div className="div-height"> </div>
        <div className="contact-title">אנא השאירו פרטיכם ונשמח לחזור אליכם בהקדם</div >


        {/* <img> src="/images/Pictures/247583.jpg" </img> */}


        <div className="mama">
          <div className="man1">
            <div className="contact-text-title">איש קשר מעודכן</div>
            <div className="input1">
              <TextField
                // style={{
                //   // backgroundColor: "gainsboro",
                //   width: "75%"
                // }}
                id="nameFirst"
                label="שם מלא"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.nameFirst}
                onChange={(e) => { handleChange(e, "nameFirst") }}
              />
              <TextField
                // style={{
                //   // backgroundColor: "gainsboro",
                //   width: "75%"
                // }}
                id="emailFirst"
                label="כתובת מייל"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.emailFirst}
                onChange={(e) => { handleChange(e, "emailFirst") }}
              />

              {/* <TextField tyle={{
                backgroundColor: "gainsboro",
                width: "75%"
              }}
                id="PhoneFirst"
                label="מספר טלפון"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj?.PhoneFirst}
                onChange={(e) => { handleChange(e, "PhoneFirst") }}
              /> */}

              <TextField
                // style={{
                //   // backgroundColor: "gainsboro",
                //   width: "75%"
                // }}
                id="PhoneFirst"
                label="טלפון"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.PhoneFirst}
                onChange={(e) => { handleChange(e, "PhoneFirst") }}
              />
            </div>
          </div>
          {/* <div className="man2">
            <div className="contact-text-title">איש קשר נוסף</div>
            <div className="input1">
              <TextField
                id="nameSecond"
                label="שם מלא"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.nameSecond}
                onChange={(e) => { handleChange(e, "nameSecond") }}
              />

              <TextField
                id="emailSecond"
                label="כתובת מייל"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.emailSecond}
                onChange={(e) => { handleChange(e, "emailSecond") }}
              />

              <TextField
                id="PhoneSecond"
                label="מספר טלפון"
                className="margin-text-input"
                multiline
                maxRows={4}
                value={contactObj.PhoneSecond}
                onChange={(e) => { handleChange(e, "PhoneSecond") }}
              />
            </div>
          </div> */}
        </div>
        <div 
        style={{
          paddingRight: "5%", direction: "rtl"
        }}>
          <div >
            <FormControl>
              <Select 
                value={value}
                // label="נושא"
                class="text-all-contact"
                onChange={handleChange}
                // displayEmpty
                // inputProps={{ 'aria-label': 'Without label' }}
                style={{ width: 570 ,marginBottom:"15px"}}
              >
                <MenuItem className="rtl" value="">
                  <em >סוג הפניה</em>
                </MenuItem>
                <MenuItem className="rtl" value={10}>תיאום אספקה</MenuItem>
                <MenuItem className="rtl" value={20}>בקשת החזרה</MenuItem>
                <MenuItem className="rtl" value={30}>דיווח על שבר</MenuItem>
                <MenuItem className="rtl" value={40}>דיווח על בעיית איכות</MenuItem>
                <MenuItem className="rtl" value={50}>תקלת אצוות</MenuItem>
                <MenuItem className="rtl" value={60}>טעות באספקה</MenuItem>
                <MenuItem className="rtl" value={70}>בירורים שונים</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
            {/* <TextField
              style={{ width: "300px !importent" }}
              id="message"
              label="ההודעה שלך"
              multiline
              className="text-all-contact"
              maxRows={20}
              value={contactObj?.message}
              onChange={(e) => { handleChange(e, "message") }}

            /> */}
            <TextareaAutosize className="contact-text-title"
              aria-label="minimum height"
              minRows={5}
              onChange={(e) => { handleChange(e, "message") }}
              value={contactObj.message}
              placeholder="ההודעה שלך..."
              style={{ width: 550 }}
            />
          </div>
        </div>

        <div style={{
          display: "flex",
          paddingRight: "5%",
          justifyContent: "end"
        }}>
          <Button variant="contained" 
          sx={{ backgroundColor: "gray", '&:hover': { backgroundColor: "Silver" } }}
           startIcon={<ArrowBackIcon />} onClick={CreateActivity}>
            שליחה
          </Button>
          {/* endIcon={<ArrowBackIcon />} */}
        </div>
      </div>
    </div >

    // <div >
    //   <link href="//netdna.bootstrapcdn.com/bootstrap/3.1.0/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css" />
    //   <script src="//netdna.bootstrapcdn.com/bootstrap/3.1.0/js/bootstrap.min.js"></script>
    //   <script src="//code.jquery.com/jquery-1.11.1.min.js"></script>


    //   <div classclass="container">
    //     <div className="row">
    //       <div className="col-md-6 col-md-offset-3">
    //         <div className="well well-sm">
    //           <form className="form-horizontal" action="" method="post">
    //             <fieldset>
    //               <legend className="text-center">Contact us</legend>


    //               <div className="form-group">
    //                 <label className="col-md-3 control-label" for="name">Name</label>
    //                 <div className="col-md-9">
    //                   <input id="name" name="name" type="text" placeholder="Your name" class="form-control" />
    //                 </div>
    //               </div>


    //               <div className="form-group">
    //                 <label className="col-md-3 control-label" for="email">Your E-mail</label>
    //                 <div className="col-md-9">
    //                   <input id="email" name="email" type="text" placeholder="Your email" className="form-control" />
    //                 </div>
    //               </div>


    //               <div className="form-group">
    //                 <label className="col-md-3 control-label" for="message">Your message</label>
    //                 <div className="col-md-9">
    //                   <textarea className="form-control" id="message" name="message" placeholder="Please enter your message here..." rows="5"></textarea>
    //                 </div>
    //               </div>


    //               <div className="form-group">
    //                 <div className="col-md-12 text-right">
    //                   <button type="submit" className="btn btn-primary btn-lg">Submit</button>
    //                 </div>
    //               </div>
    //             </fieldset>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>

  );
};
export default PersonalArea;